import { render, staticRenderFns } from "./EventTimeSlots.vue?vue&type=template&id=58cea960&scoped=true"
import script from "./EventTimeSlots.vue?vue&type=script&lang=js"
export * from "./EventTimeSlots.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58cea960",
  null
  
)

export default component.exports